import { useEffect } from "react";
import { SubHeadingTitle } from "../../../../components/shared";
import styles from "./checkoutshipping.module.css";
import { LiaRupeeSignSolid } from "react-icons/lia";
const CheckoutShipping = ({
  shippingRules,
  selectedShipping,
  setSelectedShipping,
  subtotal,
}) => {
  const isAbove1000 = subtotal >= 1000;
  // ✅ AUTO SELECT BASED ON AMOUNT
  useEffect(() => {
    if (!shippingRules || shippingRules.length === 0) return;
    if (isAbove1000) {
      // select min_cost (Express)
      const expressRule = shippingRules.find(
        (rule) => rule.type === "min_cost"
      );
      if (expressRule) {
        setSelectedShipping(expressRule);
      }
    } else {
      // select flat_cost (₹10)
      const flatRule = shippingRules.find(
        (rule) => rule.type === "flat_cost"
      );
      if (flatRule) {
        setSelectedShipping(flatRule);
      }
    }
  }, [subtotal, shippingRules, isAbove1000, setSelectedShipping]);
  const getShippingCost = () => {
    if (!selectedShipping) return 0;
    if (selectedShipping.type === "flat_cost") {
      return Number(selectedShipping.cost);
    }
    if (selectedShipping.type === "min_cost") {
      return subtotal >= Number(selectedShipping.min_cost)
        ? 0
        : Number(selectedShipping.cost);
    }
    return 0;
  };
  const shippingCost = getShippingCost();
  return (
    <div className={styles.shippingBox}>
      <div className={styles.shippingTitle}>
        Select Shipping Method
      </div>
      <div className={styles.shippingOptions}>
        {shippingRules.map((rule) => {
          const disableRule =
            (isAbove1000 && rule.type === "flat_cost") ||
            (!isAbove1000 && rule.type === "min_cost");
          return (
            <label
              key={rule.id}
              className={styles.shippingOption}
              style={{
                opacity: disableRule ? 0.5 : 1,
                pointerEvents: disableRule ? "none" : "auto",
              }}
            >
              <input
                type="radio"
                name="shipping"
                value={rule.id}
                disabled={disableRule}
                checked={selectedShipping?.id === rule.id}
                onChange={() => setSelectedShipping(rule)}
              />
              <span className={styles.optionLabel}>
                {rule.name} (
                {rule.type === "flat_cost"
                  ? `₹${rule.cost}`
                  : `Free above ₹${rule.min_cost}`}
                )
              </span>
            </label>
          );
        })}
      </div>
      {selectedShipping && (
        <SubHeadingTitle
          style={styles.amountRow}
        />
      )}
    </div>
  );
};
export default CheckoutShipping;